import { i18n } from "@libs/i18n";
import { CertificateStatusType } from "@/domain/certificate";

export const formatCertificateStatus = (status: CertificateStatusType) => {
  switch (status) {
    case "SENT":
      return i18n.t("common:sent");
    case "FAILED":
      return i18n.t("common:failed");
    default:
      return "";
  }
};
